import { P, Predicate } from "breadcommon";
import { DollarAmount } from "../common/DollarAmount";

export interface TransactionColumnFilterDisplayAmountProps {
  predicate: Predicate;
}

export function TransactionColumnFilterDisplayAmount({
  predicate,
}: TransactionColumnFilterDisplayAmountProps): JSX.Element {
  // Parse the predicate to extract min/max values
  // Expected structure: P.All(P.GreaterThanEqualTo(...), P.LessThanEqualTo(...)) or just one of them
  const serializable = predicate.asSerializable();

  let minAmount: number | null = null;
  let maxAmount: number | null = null;

  if (serializable.name === P.OpName.All && serializable.args.length > 0) {
    // Multiple conditions in P.All
    for (const arg of serializable.args) {
      if (arg.name === P.OpName.GreaterThanEqualTo && arg.args.length === 2) {
        const literalOp = arg.args[1];
        if (
          literalOp.name === P.OpName.Literal &&
          typeof literalOp.args[0] === "number"
        ) {
          minAmount = literalOp.args[0];
        }
      } else if (
        arg.name === P.OpName.LessThanEqualTo &&
        arg.args.length === 2
      ) {
        const literalOp = arg.args[1];
        if (
          literalOp.name === P.OpName.Literal &&
          typeof literalOp.args[0] === "number"
        ) {
          maxAmount = literalOp.args[0];
        }
      }
    }
  } else if (
    serializable.name === P.OpName.GreaterThanEqualTo &&
    serializable.args.length === 2
  ) {
    // Single min condition
    const literalOp = serializable.args[1];
    if (
      literalOp.name === P.OpName.Literal &&
      typeof literalOp.args[0] === "number"
    ) {
      minAmount = literalOp.args[0];
    }
  } else if (
    serializable.name === P.OpName.LessThanEqualTo &&
    serializable.args.length === 2
  ) {
    // Single max condition
    const literalOp = serializable.args[1];
    if (
      literalOp.name === P.OpName.Literal &&
      typeof literalOp.args[0] === "number"
    ) {
      maxAmount = literalOp.args[0];
    }
  }
  const displayAmount = (amount: number) => (
    <DollarAmount
      n={amount}
      showDollarSign={true}
      size="sm"
      align="span"
      showMinus={true}
      includeDecimals={true}
    />
  );

  if (minAmount !== null && maxAmount !== null) {
    return (
      <span>
        {displayAmount(minAmount)} to {displayAmount(maxAmount)}
      </span>
    );
  } else if (minAmount !== null) {
    return <span>≥ {displayAmount(minAmount)}</span>;
  } else if (maxAmount !== null) {
    return <span>≤ {displayAmount(maxAmount)}</span>;
  }

  // Fallback if predicate structure is unexpected
  return <span>Amount filter</span>;
}
